import { writable } from "svelte/store";

export const openSheetID = writable<string | null>(null);
export const openSheet = writable<HTMLOcSheetV1Element | null>();
export const sheetHistory = writable<string[]>([]);
export const isBackNavigation = writable(false);
export const documentScrollingDisabled = writable(false);
export const activeElement = writable<HTMLElement | null>(null);
